/**
 * @generated SignedSource<<977a4ecc457733585032233dca4ff3eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicLinkTopic$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "topicLinkTopic";
};
export type topicLinkTopic$key = {
  readonly " $data"?: topicLinkTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicLinkTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicLinkTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "dc4edfa4be4a0096ecc8a1c54133a811";

export default node;
